import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HeartIcon, ActivityIcon, SparklesIcon } from 'lucide-react';
export function InclusionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const audiences = [{
    icon: HeartIcon,
    title: 'Celíacas',
    description: 'Que extrañan textura real y no quieren vivir a galleta de arroz'
  }, {
    icon: ActivityIcon,
    title: 'Diabetes / Cuidado de Glucosa',
    description: 'Personas que quieren evitar bombas de azúcar encubiertas'
  }, {
    icon: SparklesIcon,
    title: 'Quiero Cuidarme',
    description: 'Mujeres que quieren comer más sano sin mentalidad de "prohibido/permitido"'
  }];
  return <section ref={ref} className="w-full bg-wheat/10 px-4 py-16 md:py-24" data-id="element-36">
      <div className="max-w-6xl mx-auto" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-38">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-6" data-id="element-39">
            Para Quién Es Este Ebook
          </h2>
          <p className="font-body text-lg md:text-xl text-brown/80 max-w-3xl mx-auto" data-id="element-40">
            Este ebook está pensado para que{' '}
            <span className="font-semibold text-terracotta" data-id="element-41">
              todas puedan disfrutar panadería rica
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-42">
          {audiences.map((audience, index) => {
          const Icon = audience.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: 0.2 + index * 0.15
          }} className="bg-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow duration-300" data-id="element-43">
                <div className="w-16 h-16 bg-terracotta/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-44">
                  <Icon className="w-8 h-8 text-terracotta" data-id="element-45" />
                </div>
                <h3 className="font-heading text-2xl font-bold text-brown mb-4" data-id="element-46">
                  {audience.title}
                </h3>
                <p className="font-body text-base text-brown/80 leading-relaxed" data-id="element-47">
                  {audience.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-48">
          <p className="font-body text-lg text-brown/80" data-id="element-49">
            Y también para vos si estás cansada de gastar fortuna en productos
            "sin" que no valen lo que cuestan.
          </p>
        </motion.div>
      </div>
    </section>;
}